import { create } from 'zustand';

import { i18n } from '@/i18n/i18n';

type Direction = 'ltr' | 'rtl';

const RTL_LANGUAGES = new Set(['ar']);

function directionFromLang(lang: string): Direction {
  return RTL_LANGUAGES.has(lang) ? 'rtl' : 'ltr';
}

interface DirectionState {
  direction: Direction;
}

export const useDirectionStore = create<DirectionState>()(() => ({
  direction: directionFromLang(i18n.language),
}));

// Keep direction store in sync with i18n — single source of truth.
// Fires for ALL language changes (LanguageSwitcher, detection, fallback).
i18n.on('languageChanged', (lang: string) => {
  const dir = directionFromLang(lang);
  document.documentElement.dir = dir;
  document.documentElement.lang = lang;
  useDirectionStore.setState({ direction: dir });
});
